import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Upload, Sparkles, Plus } from "lucide-react";

const ActionsBar = ({
  uploading,
  onFileUpload,
  autoMatching,
  onAutoMatchAll,
  itemsCount,
  onAddTypeClick,
  onAddItemClick
}) => {
  return (
    <div className="flex items-center gap-3 bg-slate-50 p-3 rounded-lg">
      <div className="flex-1 flex flex-wrap gap-3">
        <Label
          htmlFor="windoorcraft-upload"
          className="cursor-pointer inline-flex items-center gap-2 px-4 py-2 bg-white border rounded-lg hover:bg-slate-50 transition-colors"
        >
          <Upload className="w-4 h-4" />
          {uploading ? "Importando..." : "Cargar Excel WindoorCraft"}
        </Label>
        <input
          id="windoorcraft-upload"
          type="file"
          accept=".xlsx,.xls"
          onChange={onFileUpload}
          className="hidden"
          disabled={uploading}
        />
        
        {/* Auto-Match Button */}
        <Button
          variant="outline"
          onClick={onAutoMatchAll}
          disabled={autoMatching || itemsCount === 0}
          className="bg-gradient-to-r from-purple-50 to-blue-50 border-purple-200 hover:border-purple-300 hover:from-purple-100 hover:to-blue-100"
        >
          <Sparkles className="w-4 h-4 mr-2 text-purple-500" />
          {autoMatching ? "Buscando..." : "Auto-Match Precios"}
        </Button>
        
        {/* Add Manual Type to Price List */}
        <Button
          variant="outline"
          onClick={onAddTypeClick}
          className="text-green-600 border-green-200 hover:bg-green-50 hover:border-green-300"
        >
          <Plus className="w-4 h-4 mr-2" />
          Añadir Tipo Manual
        </Button>
      </div>
      <Button
        variant="outline"
        onClick={onAddItemClick}
      >
        <Plus className="w-4 h-4 mr-2" />
        Agregar Item
      </Button>
    </div>
  );
};

export default ActionsBar;
